import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFileText, FiClock, FiCheckCircle } = FiIcons;

const ApplicationGuide = () => {
  const requirements = [
    "Business name & address",
    "Federal Tax ID (EIN)",
    "Industry type",
    "Number of employees",
    "Annual revenue",
    "Coverage amounts"
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            What You'll Need
          </h2>
          <p className="text-xl text-gray-600">
            Have these ready for a 10-minute application
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-white rounded-3xl p-8 shadow-lg"
          >
            <div className="flex items-center space-x-3 mb-6">
              <SafeIcon icon={FiFileText} className="text-blue-600 text-2xl" />
              <h3 className="text-2xl font-bold text-gray-900">Required Info</h3>
            </div>
            <div className="space-y-4">
              {requirements.map((req, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <SafeIcon icon={FiCheckCircle} className="text-green-600 flex-shrink-0" />
                  <span className="text-gray-700">{req}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-white rounded-3xl p-8 shadow-lg"
          >
            <div className="flex items-center space-x-3 mb-6">
              <SafeIcon icon={FiClock} className="text-blue-600 text-2xl" />
              <h3 className="text-2xl font-bold text-gray-900">Timeline</h3>
            </div>
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <span className="font-semibold text-gray-900">Application</span>
                <span className="text-blue-600 font-medium">10 minutes</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="font-semibold text-gray-900">Quote</span>
                <span className="text-blue-600 font-medium">Instant</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="font-semibold text-gray-900">Payment</span>
                <span className="text-blue-600 font-medium">1 minute</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="font-semibold text-gray-900">Coverage</span>
                <span className="text-blue-600 font-medium">Same day</span>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <motion.a
            href="https://quote.burbankinsuranceservices.com/Jn9lan"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-colors duration-300 inline-block"
          >
            Start Application
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default ApplicationGuide;